import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: center; */
  padding: 0 2%;
  margin: 0 7%;
  margin-top: 2.44em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 0;
    margin: 0 5%;
  }
`;
export const Heading = styled.div`
  color: #626262;
  font-size: 1.1875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 2.25em;
  /* height: 100%; */
  padding: 0 1%;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 2.44em;
    margin-left: 1em;
    font-size: 1.2em;
  }
`;
export const Add = styled.div`
  width: 2rem;
  height: 2rem;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 1.5rem;
    height: 1.5rem;
  }
`;
export const AddContainer = styled.div`
  /* width: 100%; */
  cursor: pointer;
  margin: 0 1%;
  height: 3.375rem;
  border-radius: 1.1875rem;
  border: 0px solid #f1f1f1;
  background: #fff;
  box-shadow: 0px 0px 14px 0px rgba(227, 227, 227, 0.25);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2em;
  margin-bottom: 2.5em;
  h2 {
    color: #626262;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
export const LinkContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1%;
  /* justify-content: space-between; */
  align-items: center;
  overflow-y: hidden;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    padding: 0;
  }
`;
export const Link = styled.div`
  position: relative;
  width: 100%;
  height: 6.25rem;
  border-radius: 1.1875rem;
  border: 0px solid #f1f1f1;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(217, 217, 217, 0.25);
  display: flex;
  align-items: center;
  padding: 0 2em;
  margin-bottom: 1.12em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    padding: 0 1em;
    height: 6.25rem;
    margin-bottom: 0.5em;
  }
`;
export const LinkImage = styled.div`
  margin-right: 2em;
  width: 5.875em;
  height: 4.0625em;
  flex-shrink: 0;
  border-radius: 0.8125em;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    url(<path-to-image>), lightgray 50% / cover no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-right: 1em;
    width: 4.3em;
    height: 3.5em;
    flex-shrink: 0;
  }
`;
export const LinkName = styled.div`
  display: block;
  h2 {
    color: #626262;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    h2 {
      color: #626262;
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      width: 8.45em;
      white-space: nowrap; /* Prevent text from wrapping */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
export const LinkUrl = styled.div`
  color: #9e9e9e;
  display: block;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    p {
      white-space: nowrap; /* Prevent text from wrapping */
      overflow: hidden;
      width: 9em;
      text-overflow: ellipsis;
    }
  }
`;
export const LinkClicks = styled.div`
  display: flex;
  gap: 0.4em;
  color: #9e9e9e;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 2.75em;
  width: fit-content;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    color: #9e9e9e;
    font-family: Inter;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
export const LinkStar = styled.div`
  cursor: pointer;
  margin-right: 2.75em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: 1.4em;
    right: -1.75em;
  }
`;
export const LinkEdit = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 1.125rem;
    height: 1.125rem;
  }
`;
export const NameAndLink = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;
export const LinkDelete = styled.div`
  cursor: pointer;
  margin-right: 2.3em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-right: 0.7em;
    width: 0.9375rem;
    height: 0.9375rem;
    flex-shrink: 0;
  }
`;
export const Group2 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;
export const Group1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-direction: column;
  }
`;
export const StarIcon = styled.div``;
export const LinkEditIcon = styled.div`
  img {
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    @media (max-width: ${({ theme }) => theme.mobile.md}) {
      width: 1.125rem;
      height: 1.125rem;
      flex-shrink: 0;
    }
  }
`;
export const LinkDeleteIcon = styled.div`
  cursor: pointer;
`;

export const ModalBackground = styled.span`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;
export const ModalCard = styled.span`
  width: 24.375rem;
  height: 35.375rem;
  background: #fff;
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
  position: relative;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 20.375rem;
  }
`;
